export const TIPO_RELATORIO = (id) => {
    const relatorios = {
        '12': 'Detalhe_Contato',
        '1' : 'Resumido_envio_leitura',
        '19' : 'Resumido_envio_leitura',
        '2' : 'Não_Recebido',
        '14' : 'Não_Recebido',
        '20' : 'Não_Recebido',
        '3' : 'Volumetria',
        '10' : 'Volumetria',
        '21' : 'Volumetria',
        '13' : 'Detalhe_Contato',
        '15' : 'Detalhe_Contato_Unificado',
        '16' : 'Faturamento_CarimboTempo',
        '17' : 'Faturamento_CarimboTempo',
        '18' : 'Contabilizacao',
        '22' : 'Detalhe_Contato_Whatsapp',
        '23' : 'Detalhe_Agendamento',
        '24' : 'Detalhado_Simplificado',
        '25' : 'Volumetria_Usuario',
        '26' : 'Resumido_envio_leitura',
    };
    return relatorios[id];
};